var _defs, _tspan, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs74(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "59.223515mm",
    height: "132.29166mm",
    viewBox: "0 0 59.223515 132.29166",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(7.4016139e-7,-164.70833)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g280",
    transform: "matrix(1.3727918,0,0,1.3727918,-14.057014,-21.282774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text108",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE087"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "m 53.380657,139.8134 c 0,-2.64584 0,-3.8485 -1.683717,-3.8485 -0.120265,0 -1.563451,0.3608 -2.044513,1.08239 -0.601327,1.08239 -1.924248,6.6146 -4.329557,6.6146 -2.405309,0 -6.975397,-8.17805 -14.912919,-8.17805 -5.652477,0 -7.095662,2.16478 -8.418583,3.4877 -1.32292,1.20266 -1.924247,1.56345 -2.64584,1.68372 -0.721593,0 -1.924248,-1.32292 -2.405309,-2.28505 -0.240531,-0.36079 -0.721593,-0.72159 -1.202655,-0.72159 -0.481062,0 -0.962124,0.3608 -0.962124,1.20266 v 15.87504 c 0,0 0.120266,1.56345 1.082389,1.56345 0.721593,0 1.08239,-0.96212 1.443186,-1.92425 0.962124,-2.40531 2.164778,-8.05778 6.494335,-8.05778 3.848496,0 8.538849,7.21592 14.071061,7.21592 2.64584,0 4.089026,-1.44318 4.810619,-2.04451 0.240531,-0.12026 0.721592,-0.3608 0.841858,-0.3608 0.360796,0 0.601327,0.3608 0.721593,0.84186 0,2.76611 -7.45646,8.17805 -13.229202,14.91292 -3.607964,4.32956 -6.614601,9.86177 -6.614601,13.59 0,2.04451 0,3.00664 1.803982,3.00664 1.803982,0 3.848495,-0.84186 6.253804,-0.84186 2.40531,0 6.975398,0.84186 7.937522,0.84186 0.962123,0 1.563451,-0.7216 1.563451,-3.60797 0,-15.99531 11.42522,-29.82584 11.42522,-39.6876 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text39",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE084"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path273",
    d: "m 43.192466,214.89329 v -20.5654 c 0,-0.72159 -0.120265,-1.68372 -1.202654,-1.68372 -0.841859,0 -1.322921,0.24053 -1.924248,0.96213 l -9.140176,11.06442 c -0.360796,0.48106 -0.841858,0.96212 -0.841858,2.16478 v 8.05779 H 17.094859 c 7.69699,-6.49434 23.09097,-28.38266 23.331501,-29.46505 0,-0.12026 0.120266,-0.24053 0.120266,-0.48106 0,-0.72159 -0.721593,-1.32292 -1.443186,-1.32292 -0.841858,0 -4.810619,0.24053 -6.494335,0.24053 -1.803982,0 -6.133539,-0.24053 -6.855132,-0.24053 -0.841859,0 -2.285044,0.3608 -2.285044,1.80398 0,12.02655 -9.380707,25.37602 -12.267078,29.34478 l -0.601328,0.84186 c 0,0.12026 -0.120265,0.12026 -0.120265,0.24053 -0.120266,0.3608 -0.240531,0.84186 -0.240531,1.08239 0,0.96212 0.721593,1.68372 1.924247,1.68372 H 30.08353 v 6.01327 c 0,2.64584 -2.164779,3.36743 -3.848495,3.36743 -1.563451,0 -2.285044,0.84186 -2.285044,1.80398 0,0.96213 0.481062,2.04452 1.924247,2.04452 h 20.445131 c 0.962123,0 1.924247,-0.7216 1.924247,-2.04452 0,-1.32292 -1.202655,-1.92424 -2.164778,-1.92424 -0.962124,0 -2.886372,-0.60133 -2.886372,-3.60797 v -5.65247 h 6.975398 c 0.962123,0 1.443185,-0.7216 1.443185,-1.92425 0,-1.08239 -0.360796,-1.80398 -1.443185,-1.80398 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs74);
export default __webpack_public_path__ + "static/media/ts-7-4.cccf185c94b506a696d973ee11ab8865.svg";
export { ForwardRef as ReactComponent };